import type { AssistantWebsitePage } from "@/types/assistant";
import type { MaybeRef } from "vue";

export function getAssistantWebsitePagesQueryKey(
  id: MaybeRef<string> = "website#website"
) {
  return ["assistant-data", "pages", id];
}

export function useAssistantWebsitePagesRequest(websiteId: MaybeRef<string>) {
  const enabled = computed(() => !!unref(websiteId));
  const query = useQuery({
    queryKey: getAssistantWebsitePagesQueryKey(websiteId),
    queryFn: async () => {
      const response = await useGetRequest<{ items: AssistantWebsitePage[] }>(
        "/account/data",
        {
          params: {
            itemId: unref(websiteId),
            getSubItems: true,
          },
        }
      );
      return response?.data?.items || null;
    },
    select(data) {
      return data?.sort(
        (a, b) => (a.sourceData?.depth || 0) - (b.sourceData?.depth || 1)
      );
    },
    staleTime: 3 * MINUTE,
    enabled: enabled,
  });
  return query;
}
